import { httpClient } from 'utils/httpClient';
import { HijoVinculado } from 'types/padre.types';

// ============================================================
// padreService — vinculación padre ↔ matrícula
// ============================================================

export const padreService = {

  // GET /padres/mis-hijos — hijos del padre autenticado
  async getMisHijos(): Promise<HijoVinculado[]> {
    try {
      const data = await httpClient.get<HijoVinculado[]>('/padres/mis-hijos');
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  },

  // POST /padres/{padreId}/vincular — vincula padre a una matrícula
  async vincular(padreId: number, matriculaId: number): Promise<HijoVinculado> {
    return httpClient.post<HijoVinculado>(`/padres/${padreId}/vincular`, { matriculaId });
  },

  // DELETE /padres/{padreId}/vincular/{matriculaId} — soft delete del vínculo
  async desvincular(padreId: number, matriculaId: number): Promise<void> {
    return httpClient.delete<void>(`/padres/${padreId}/vincular/${matriculaId}`);
  },

  // GET /padres/matricula/{matriculaId}/padres — vínculos padre↔matrícula (misma forma que HijoVinculado)
  async getByMatricula(matriculaId: number): Promise<HijoVinculado[]> {
    try {
      const data = await httpClient.get<HijoVinculado[]>(`/padres/matricula/${matriculaId}/padres`);
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  },
};
